module.exports = __webpack_public_path__ + "static/media/link-extern.3ac47782.svg";